import script from "./InstruccionesConMartillero.vue?vue&type=script&setup=true&lang=js"
export * from "./InstruccionesConMartillero.vue?vue&type=script&setup=true&lang=js"

import "./InstruccionesConMartillero.vue?vue&type=style&index=0&id=0d96e92e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d96e92e"]])

export default __exports__